namespace Gordic.Pod.Dlg
{
    const { gcontent } = Decorators

    @gcontent
    export class OdeslaniPotvrzeniODoruceniDlg extends GContentBase<Gordic.Wfl.AC.WflBaseAC> 
    {
        model: Interface.GOdeslaniPotvrzeniElPodaniDto;
        onContentReady()
        {
            this.SetData();
            Gordic.Wfl.AC.WflBaseAC.InitControl(this);
            this.topActions.push(this.CreateActionOdeslat());
            this.topActions.push(this.CreateActionNeodeslat());
            Gordic.Wfl.AC.WflBaseAC.CompleteMenu(this);
        }

        SetData()
        {
            const form = new Gordic.Forms
                .Form({ name: "frmPotvrzeni", layoutDescriptor: "L1M1S1" })
                .addSection()
                .addRow("jres:23900017") //RC 23900017 : Adresát
                .addField("gstringbox", { name: "adrTo", disabled: true })
                .addRow("jres:23900055") //RC 23900055 : Předmět
                .addField("gstringbox", { name: "subject", disabled: true })
                .addRow("jres:23900056") //RC 23900056 : Přílohy
                .addField("gstringbox", { name: "prilohy", disabled: true })
                .addRow("jres:23900057") //RC 23900057 : Obsah
                .addField("gstringbox", { name: "text", disabled: true, rows: 6 });

            form.addRow().addField("gcheck", "", { name: "podepsat", disabled: !this.model.podepsatEnabled, label: "jres:23900074" }); //RC 23900074 : Podepsat

            this.defaultForm = $("<div>").appendTo(this.element).gform("createFrom", form);
            this.findFields().gfield("model", "apply", this.model);
        }

        CreateActionOdeslat(): GAction {
            var that = this;
            var action = new GAction({
                name: "actOdeslat",
                icon: Gordic.Gin.Icons.ActionEnum.odeslat,
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite,
                caption: "jres:23900075",  //RC 23900075 : Odeslat potvrzení
                run: function (ev, ctx)
                {
                    that.findForms("frmPotvrzeni").findFields().gfield("model", "collect", that.model);
                    that.CreateFile().done(
                        
                        function (retVal)
                        {
                            if (retVal) that.DokoncitAZavrit();
                        })
                        .fail(function (reason) { that.endOperation(); that.dialogs.warning(reason.statusText); });
                }
            });
            return action;
        }

        CreateFile(): JQuery.Promise<boolean>
        {
            var that = this;
            let promis = $.Deferred<boolean>();
            that.OtazkaZdaPodepsatSouborPotvrzeni()
                .done(function (podepsat)
                {
                    that.model.podepsatPrilohu = podepsat;
                    Gin.Globals.ShowWaitInfo(that, "jres:23900196"); //RC 23900196 : Probíhá příprava odeslání
                    that.call<Pod.Interface.GOdeslaniPotvrzeniElPodaniDto>("CreateFile", { model: that.model })
                        .done(function (retVal) { // vytvořím soubor potvrzeni
                            that.endOperation();
                            that.model = retVal;
                            if (that.model.podepsat == false && retVal.podepsatPrilohu == false)
                            {
                                that.DokoncitAZavrit();
                            }
                            else
                            {       
                                if (retVal.podepsatPrilohu)
                                {
                                    Gin.Globals.ShowWaitInfo(that, "jres:23900244"); //RC 23900244 : Probíhá podepisování
                                    that.CreateSign(retVal.fileGuid!, that.model.nazevPrilohy)
                                        .done(function (signResult) {
                                            that.endOperation();
                                            if (signResult)
                                            {
                                                if (signResult.errorMsg) {
                                                    that.dialogs.warning(signResult.errorMsg);
                                                    promis.resolve(false);
                                                }
                                                else
                                                {
                                                    Gin.Globals.ShowWaitInfo(that, "jres:23900245"); //RC 23900245 : Probíhá vytvoření odpovědi
                                                    that.call<Pod.Interface.GOdeslaniPotvrzeniElPodaniDto>("SaveFilePotvrzeniAndCreateMail", { model: that.model, SignResult: signResult })
                                                        .done(function (retVal) {
                                                            that.endOperation();
                                                            if (retVal && retVal.podepsat) {
                                                                that.model = retVal;
                                                                that.PodepisMailAOdesli()
                                                                    .done(function (retVal) {
                                                                        if (retVal) {
                                                                            promis.resolve(true)
                                                                        }
                                                                        else promis.resolve(true);
                                                                    })
                                                                    .fail(function (reason) { that.endOperation(); that.dialogs.warning(reason.statusText); });
                                                            }
                                                            else { promis.resolve(that.DokoncitAZavrit()) }
                                                        })
                                                }
                                            } else { promis.resolve(false); }
                                        }                                       
                                    )
                                     .fail(function (reason) { that.endOperation(); that.dialogs.warning(reason.statusText); });                                       
                                }
                                else
                                {
                                    that.PodepisMailAOdesli().done(function (isOk)
                                    {
                                        //that.DokoncitAZavrit();
                                        promis.resolve(isOk)

                                    })
                                    .fail(function (reason) { that.endOperation(); that.dialogs.warning(reason.statusText); });
                                }
                            }
                        });
                });
            return promis.promise();
        }        

        CreateSign(guidFile: string, nameFile: string): JQuery.Promise<Gordic.Wfl.WebClient.GSignatureResultDtoWithGuids | null> {
            let promis = $.Deferred<Gordic.Wfl.WebClient.GSignatureResultDtoWithGuids | null>();
            var that = this;
            Gin.Globals.ShowWaitInfo(that, "jres:23900244"); //RC 23900244 : Probíhá podepisování
            Gordic.Wfl.Utils.SignObj.PodepisovaniApp.sign
            ({
                file: guidFile,
                fileName: nameFile,
                signTime: new Date(),
                idSigningReason: this.model.ixsDpo
            })
            .then((signedConfig: Gordic.Wfl.WebClient.GSignatureResultDtoWithGuids) => {
                promis.resolve(signedConfig);
            }, (reason) => { 
                    Gordic.Gui.WebApp.Utils.showReasonFlash(that, reason);
                    if (!reason.handled) { that.dialogs.warning(reason.reason); }                                     
                     promis.resolve(null);
            })
            return promis.promise();
        }

        PodepisMailAOdesli() : JQuery.Promise<boolean>
        {
            let promis = $.Deferred<boolean>();
            var that = this;
            Gin.Globals.ShowWaitInfo(that, "jres:23900244"); //RC 23900244 : Probíhá podepisování
            this.CreateSign(this.model.fileGuid!, this.model.fileName).done(function (signResult)
            {
                that.endOperation();
                if (signResult)
                {
                    Gin.Globals.ShowWaitInfo(that, "jres:23900246"); //RC 23900246 : Probíhá odeslání potvrzení
                    that.call<boolean>("OdeslatPodepsanyMailPotvrzeni", { model: that.model, SignResult: signResult })
                        .done(function (retVal) {
                            that.endOperation();
                            promis.resolve(that.DokoncitAZavrit())
                        })
                        .fail(function (reason) { that.endOperation(); that.dialogs.warning(reason.statusText); });
                } else { promis.resolve(false); }
            });

            return promis.promise();
        }

        OtazkaZdaPodepsatSouborPotvrzeni(): JQuery.Promise<boolean>
        {
            let promis = $.Deferred<boolean>();
            if (this.model.podepsatPrilohu == null)
            {
                this.dialogs.confirm("jres:23900067", "jres:23900078").on("close", function (ev, retVal)
                {
                    promis.resolve(retVal === "yes");
                });
            } else promis.resolve(this.model.podepsatPrilohu)       
            return promis.promise();
        }

        DokoncitAZavrit(): boolean
        {
            Gin.Globals.ShowWaitInfo
            Gordic.Wfl.AC.WflBaseAC.ResolveInfo(this);
            var l_ok = this.ResultType == Gin.Interface.TypVysledkuOperace.Provedeno
            if (l_ok) this.Zavrit(l_ok);
            return l_ok;
        }

        Zavrit(OK: boolean): void
        {
            this.close(OK);
        }

        CreateActionNeodeslat(): GAction {
            var that = this;
            var action = new GAction({
                name: "actOdeslat",
                icon: Gordic.Gin.Icons.ActionEnum.stornovat,
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite,
                caption: "jres:23900077",  //RC 23900077 : Neodesílat
                run: function (ev, ctx) {
                    that.call<Gordic.Gin.WebClient.GRetValDlg>("Neodeslat", { model: that.model })
                        .done(function (r) { that.Zavrit(true); })
                        .fail(function (reason) { that.endOperation(); that.dialogs.warning(reason.statusText); });
                }
            });
            return action;
        }
    }
}